import React from "react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const go = (id) => { const el = document.getElementById(id); if (el) el.scrollIntoView({ behavior: "smooth" }); };
  return (
    <footer className="pb-footer" role="contentinfo">
      <div className="fw">
        <div className="ft-top">
          <div className="ft-brand">
            <h3>Mortgage Survival Playbook 2026</h3>
            <p style={{ fontFamily: "var(--serif)", fontSize: "1.05rem", fontStyle: "italic", color: "var(--g1)", marginBottom: "0.8rem" }}>Identify earlier. Engage consistently. Govern every decision.</p>
            <p>A self-contained institutional implementation framework for earlier borrower-risk identification, structured intervention, documented engagement, and portfolio measurement. Built by Lloyd Igbokwe. ENVOLVP LLC, Houston, Texas.</p>
            <a href="mailto:hello@mortgagesurvivalplaybook.com">hello@mortgagesurvivalplaybook.com</a>
          </div>
          <div className="ft-col">
            <h4>Framework</h4>
            <a onClick={() => go("framework")}>4-Tier Framework</a>
            <a onClick={() => go("included")}>What's Included</a>
            <a onClick={() => go("implementation")}>90-Day Implementation</a>
            <a onClick={() => go("business")}>Business Case</a>
            <a onClick={() => go("preview")}>Institutional Preview</a>
          </div>
          <div className="ft-col">
            <h4>Data Sources</h4>
            <a href="https://www.attomdata.com/news/market-trends/foreclosures/" target="_blank" rel="noopener noreferrer">ATTOM August 2026 Report</a>
            <a href="https://www.mba.org" target="_blank" rel="noopener noreferrer">Mortgage Bankers Association</a>
            <a onClick={() => go("market")}>Market Data</a>
            <a onClick={() => navigate("/insights")} style={{ cursor: "pointer" }} data-testid="footer-insights-link">Insights</a>
            <a onClick={() => navigate("/about")} style={{ cursor: "pointer" }} data-testid="footer-about-link">About Lloyd Igbokwe</a>
            <a onClick={() => go("faq")}>FAQ</a>
          </div>
        </div>
        <div className="ft-bot">
          <p>
            © 2026 ENVOLVP LLC, Houston, Texas. All Rights Reserved. &nbsp;|&nbsp;
            <a onClick={() => navigate("/privacy")} style={{ cursor: "pointer" }}> Privacy Policy</a> &nbsp;|&nbsp;
            <a onClick={() => navigate("/terms")} style={{ cursor: "pointer" }}> Terms of Service</a>
          </p>
          <p style={{ fontSize: "0.75rem", color: "var(--g3)", marginTop: "0.5rem" }}>This site does not use cookies or third-party tracking. Payment processing via Stripe only. No personal data sold. The Playbook is an operational framework, not legal, regulatory, or investment advice.</p>
          <p style={{ fontSize: "0.75rem", color: "var(--g3)", marginTop: "0.3rem" }}>Market data sourced to ATTOM and MBA published reports, labeled by reporting period.</p>
          <p style={{ fontSize: "0.75rem", color: "var(--g3)", marginTop: "0.7rem" }}>
            Site built by <a href="https://envolvp.com" target="_blank" rel="noopener noreferrer" style={{ color: "var(--gold)", textDecoration: "none" }}>Envolvp</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
